/* template */
<template><div><div><es-clip @clipImg="clipImage"></es-clip></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mb7e13324"}'>
  .hidden
    display none
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mb7e13324"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexb7e13324%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexb7e13324%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mb7e13324"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexb7e13324/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-clip':getComponent(require("../clip/index.mpx?isComponent&outputPath=components%2Findex5bd640be%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
